import SiteLayout from "../layout/SiteLayout.vue";
import WebDraftLayout from "../layout/WebDraftLayout.vue";

// GeneralViews
import NotFound from "../pages/NotFoundPage.vue";

// Site page
import Login from "src/pages/site/Login.vue";
import Logout from "src/pages/site/Logout.vue";
import Cadastro from "src/pages/site/Register.vue";
import Processos from "src/pages/WebTrack/ListProcess.vue";
import Estatisticas from "src/pages/WebTrack/Estatisticas.vue";

// Webdraft page
import LoginWebDraft from "src/pages/site/LoginWebDraft.vue";
import ProcessosWebdraft from "src/pages/WebDraft/ListProcess.vue";


const ifAuthenticated = (to, from, next) => {
  let checkLoginStatus = JSON.parse(sessionStorage.getItem('loginInfo'));
  if (checkLoginStatus != null || checkLoginStatus != undefined) {
    if (checkLoginStatus.hasOwnProperty('status') && checkLoginStatus.status) {
      next();
    }else{
      next("/");
    }
  }else{
    next("/");
  }
}

const ifAuthenticatedWebDraft = (to, from, next) => {
  let checkLoginStatus = JSON.parse(sessionStorage.getItem('loginInfoWebdraft'));
  if (checkLoginStatus != null || checkLoginStatus != undefined) {
    if (checkLoginStatus.hasOwnProperty('status') && checkLoginStatus.status) {
      next();
    }else{
      next("/");
    }
  }else{
    next("/");
  }
}

const routes = [
  {
    path: "/",
    component: SiteLayout,
    redirect: "/webtrack/login",
    children: [
      {
        path: "/webtrack/login",
        name: "Login",
        component: Login,
      },
      {
        path: "/webtrack/cadastro",
        name: "Cadastro",
        component: Cadastro,
        beforeEnter: ifAuthenticated,
      },
      {
        path: "/webtrack/processos",
        name: "Processos",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Todos", tipo: null }
      },
      {
        path: "/webtrack/processos-todos",
        name: "Processos-Todos",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Todos", tipo: null }
      },
      {
        path: "/webtrack/processos-expAerea",
        name: "Processos-expAerea",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Exportação Aérea", tipo: "CAE" }
      },
      {
        path: "/webtrack/processos-impAerea",
        name: "Processos-impAerea",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Importação Aérea", tipo: "CAI" }
      },
      {
        path: "/webtrack/processos-expMaritima",
        name: "Processos-expMaritima",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Exportação Marítima", tipo: "CME" }
      },
      {
        path: "/webtrack/processos-impMaritima",
        name: "Processos-impMaritima",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Importação Marítima", tipo: "CMI" }
      },
      {
        path: "/webtrack/processos-rodoviaria",
        name: "Processos-rodoviaria",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Rodoviaria", tipo: "T%" }
      },
      {
        path: "/webtrack/processos-outros",
        name: "Processos-outros",
        component: Processos,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Outros", tipo: "PRO" }
      },
      {
        path: "/webtrack/estatisticas",
        name: "estatisticas",
        component: Estatisticas,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Todos", tipo: null }
      }
    ],
  },{
    path: "/webtrack",
    componente: SiteLayout,
    redirect: "/webtrack/login"
  },
  {
    path: "/webdraft",
    component: WebDraftLayout,
    redirect: "/webdraft/login",
    children: [
      {
        path: "/webdraft/login",
        name: "LoginWebDraft",
        component: LoginWebDraft,
      },
      {
        path: "/webdraft/processos",
        name: "Processos",
        component: ProcessosWebdraft,
        beforeEnter: ifAuthenticated,
        props: { categoria: "Todos", tipo: null }
      },
 
    ],
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout
  },
  { path: "*", component: NotFound }
];

export default routes;
